// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"4bc92cee","514":"8888a3c7","781":"f96e9094","920":"53fd0a71","921":"6dc400c7","956":"6ccaad40"}[chunkId] + ".chunk.css";
};